import React from 'react';

const Grid = ({layout, parts = []}) => (
  <div className='o-Grid c-Part__container'>
    {parts.map((part, idx) => (
      <div key={idx} className='o-Grid__column--33--except-small'>
        <a className='c-Part' href={part.url}>
          <div className='c-Part__inside'>
            <img className='c-Part__image'
                 src={part.image} />
            <h3 className='c-Part__title'>{part.part_id} { part.title }</h3>
            <p className='c-Part__synopsis'>{ part.part_synopsis }</p>
          </div>
        </a>
      </div>
    ))}
  </div>
);

export default Grid;



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/product/js/Grid.js